import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { CasesListComponent } from './cases-list/cases-list.component';
import { CasesDetailComponent } from './cases-detail/cases-detail.component';
import { CasesRoutingModule } from './cases-routing.module';
import { CasesDetailGeneralComponent } from './cases-detail/general/general.component';
import { CaseStateComponent } from './cases-detail/case-state/case-state.component';
import { CasesDetailClientComponent } from './cases-detail/client/client.component';
import { CasesDetailAffectedComponent } from './cases-detail/affected/affected.component';
import { CasesDetailProcessorComponent } from './cases-detail/processor/processor.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CasesDetailNoteComponent } from './cases-detail/note/note.component';
import { CasesDetailServiceComponent } from './cases-detail/service/service.component';
import { RatingModule } from 'primeng/rating';
import { FileUploadModule } from 'primeng/fileupload';
import { CasesDetailFileComponent } from './cases-detail/file/file.component';
import { MenuModule } from 'primeng/menu';
import { CaseServiceDetailComponent } from './cases-detail/service/case-service-detail/case-service-detail.component';
import { CaseServiceJobComponent } from './cases-detail/service/case-service-detail/case-service-job/case-service-job.component';
import { MessagesModule } from 'primeng/messages';
import { AccordionModule } from 'primeng/accordion';
import { CaseExpertComponent } from './cases-detail/expert/expert.component';
import { CaseExpertCreateNewComponent } from './cases-detail/expert/create-new/create-new.component';
import { CaseMediatorComponent } from './cases-detail/mediator/mediator.component';
import { CaseMediatorCreateNewComponent } from './cases-detail/mediator/create-new/create-new.component';
import { CommonModule } from '@angular/common';
import { CaseServiceTransactionLinesComponent } from './cases-detail/service/case-service-detail/case-service-transaction-lines/case-service-transaction-lines.component';
import { CaseTechnicalComponent } from './cases-detail/technical/technical.component';
import { CaseTechnicalCreateNewComponent } from './cases-detail/technical/create-new/create-new.component';
import { BadgeModule } from 'primeng/badge';
import { EditorModule } from '@tinymce/tinymce-angular';
import { TooltipModule } from 'primeng/tooltip';
import { CasesNotesFileComponent } from './cases-detail/file-note/file-note.component';
import { NotesClientComponent } from './cases-detail/notes-client/notes-client.component';
import { SelectTemplateComponent } from './cases-detail/select-templates/select-template.component';
import { PlanComponent } from './plan/plan.component';
import { CasesJobsComponent } from './cases-jobs/cases-jobs.component';
import { MessageModule } from 'primeng/message';
import { SidebarModule } from 'primeng/sidebar';
import { PhotoReportComponent } from './cases-detail/photo-report/photo-report.component';
import { IncidentsComponent } from './cases-detail/incidents/incidents.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { JobsPendingInvoiceComponent } from './cases-detail/jobs-pending-invoice/jobs-pending-invoice.component';
import { NgArrayPipesModule } from 'ngx-pipes';
import { CaseLogDetailComponent } from './cases-detail/events/case-log-detail.component';
import { CaseStateChangeComponent } from './cases-detail/case-state-change/case-state-change.component';
import { CoreModule } from 'src/app/core/core.module';
import { CaseResumeComponent } from './cases-detail/case-resume/case-resume.component';
import { CaseAgentFlowSessionComponent } from './cases-detail/case-agent-flow-session/case-agent-flow-session.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { CaseAgentFlowSessionDataComponent } from './cases-detail/case-agent-flow-session/case-agent-flow-session-data/case-agent-flow-session-data.component';
import { DeletedLabelComponent } from 'src/app/shared/components/deleted-label/deleted-label.component';


@NgModule({ declarations: [
        CasesListComponent,
        CasesDetailComponent,
        CasesDetailGeneralComponent,
        CaseStateComponent,
        CasesDetailClientComponent,
        CasesDetailAffectedComponent,
        CasesDetailProcessorComponent,
        CasesDetailNoteComponent,
        CasesDetailServiceComponent,
        CasesDetailFileComponent,
        CaseServiceDetailComponent,
        CaseServiceJobComponent,
        CaseExpertComponent,
        CaseExpertCreateNewComponent,
        CaseMediatorComponent,
        CaseMediatorCreateNewComponent,
        CaseServiceTransactionLinesComponent,
        CaseTechnicalComponent,
        CaseTechnicalCreateNewComponent,
        CasesNotesFileComponent,
        NotesClientComponent,
        SelectTemplateComponent,
        PlanComponent,
        CasesJobsComponent,
        PhotoReportComponent,
        IncidentsComponent,
        JobsPendingInvoiceComponent,
        CaseLogDetailComponent,
        CaseStateChangeComponent,
        CaseResumeComponent,
        CaseAgentFlowSessionComponent,
        CaseAgentFlowSessionDataComponent
    ],
    exports: [
        CasesDetailServiceComponent, CasesJobsComponent
    ], imports: [CoreModule,
        CommonModule,
        EditorModule,
        CasesRoutingModule,
        BrowserModule,
        FormsModule,
        TableModule,
        TagModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        FileUploadModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        ReactiveFormsModule,
        OverlayPanelModule,
        TagModule,
        RatingModule,
        FileUploadModule,
        MenuModule,
        MessagesModule,
        AccordionModule,
        BadgeModule,
        EditorModule,
        TooltipModule,
        MessageModule,
        SidebarModule,
        GoogleMapsModule,
        NgArrayPipesModule,
        MultiSelectModule,
        DeletedLabelComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CasesModule { }
